module.exports = __webpack_public_path__ + "img/corp-mob-2.ee456a20.svg";